var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpeechBubble(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_64_5301",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 3,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 3H22V21H4V3Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_64_5301)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.44499 20.9212C4.69723 21.0257 4.98756 20.968 5.18062 20.7749L5.31815 20.6374C6.27992 19.6756 7.74653 19.4275 8.95099 20.0311C10.1562 20.6351 11.5187 20.9733 12.9632 20.9726C17.8967 20.9747 21.9242 17.0295 21.9717 12.0887C22.0194 7.11612 18.0462 3.02888 13.0002 3.02888C8.03331 3.02888 3.98274 7.11035 4.02871 12.0854L4.02832 20.2976C4.02831 20.5706 4.19276 20.8168 4.44499 20.9212ZM5.37839 18.9189C6.64765 18.2175 8.20911 18.1493 9.55584 18.8242C10.576 19.3354 11.7315 19.6232 12.9628 19.6226C17.1632 19.6246 20.5815 16.2685 20.6217 12.0758C20.6623 7.84638 17.2882 4.37889 13.0002 4.37889C8.78235 4.37889 5.33809 7.85032 5.37868 12.0758L5.37839 18.9189Z",
    fill: "#999B9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8906 12C10.8906 12.4854 10.4971 12.8789 10.0117 12.8789C9.52632 12.8789 9.13281 12.4854 9.13281 12C9.13281 11.5146 9.52632 11.1211 10.0117 11.1211C10.4971 11.1211 10.8906 11.5146 10.8906 12Z",
    fill: "#999B9F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.54063 12C9.54063 11.7398 9.75154 11.5289 10.0117 11.5289C10.2719 11.5289 10.4828 11.7398 10.4828 12C10.4828 12.2602 10.2719 12.4711 10.0117 12.4711C9.75154 12.4711 9.54063 12.2602 9.54063 12ZM10.0117 12.8789C10.4971 12.8789 10.8906 12.4854 10.8906 12C10.8906 11.5146 10.4971 11.1211 10.0117 11.1211C9.52632 11.1211 9.13281 11.5146 9.13281 12C9.13281 12.4854 9.52632 12.8789 10.0117 12.8789Z",
    fill: "#999B9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9141 12C13.9141 12.4854 13.5206 12.8789 13.0352 12.8789C12.5498 12.8789 12.1562 12.4854 12.1562 12C12.1562 11.5146 12.5498 11.1211 13.0352 11.1211C13.5206 11.1211 13.9141 11.5146 13.9141 12Z",
    fill: "#999B9F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5641 12C12.5641 11.7398 12.775 11.5289 13.0352 11.5289C13.2953 11.5289 13.5063 11.7398 13.5063 12C13.5063 12.2602 13.2953 12.4711 13.0352 12.4711C12.775 12.4711 12.5641 12.2602 12.5641 12ZM13.0352 12.8789C13.5206 12.8789 13.9141 12.4854 13.9141 12C13.9141 11.5146 13.5206 11.1211 13.0352 11.1211C12.5498 11.1211 12.1562 11.5146 12.1562 12C12.1562 12.4854 12.5498 12.8789 13.0352 12.8789Z",
    fill: "#999B9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9375 12C16.9375 12.4854 16.544 12.8789 16.0586 12.8789C15.5732 12.8789 15.1797 12.4854 15.1797 12C15.1797 11.5146 15.5732 11.1211 16.0586 11.1211C16.544 11.1211 16.9375 11.5146 16.9375 12Z",
    fill: "#999B9F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5875 12C15.5875 11.7398 15.7984 11.5289 16.0586 11.5289C16.3188 11.5289 16.5297 11.7398 16.5297 12C16.5297 12.2602 16.3188 12.4711 16.0586 12.4711C15.7984 12.4711 15.5875 12.2602 15.5875 12ZM16.0586 12.8789C16.544 12.8789 16.9375 12.4854 16.9375 12C16.9375 11.5146 16.544 11.1211 16.0586 11.1211C15.5732 11.1211 15.1797 11.5146 15.1797 12C15.1797 12.4854 15.5732 12.8789 16.0586 12.8789Z",
    fill: "#999B9F"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechBubble);
export default __webpack_public_path__ + "static/media/speechBubble.4c3459313665683a25828ad0cff03ea2.svg";
export { ForwardRef as ReactComponent };